

import { Smartphone } from 'lucide-react';
import type { Product } from './types';
import { normalizeProductPricing } from './pricingNormalization';

export const iosAppSuite: Product = normalizeProductPricing({
  id: 'ios-app-development-suite',
  title: 'iOS App Development Suite',
  subtitle: 'Native iOS applications with cutting-edge Apple technologies',
  description: 'Complete iOS app development platform featuring native Swift development, SwiftUI interfaces, Core Data integration, and seamless Apple ecosystem connectivity with expert development support for UK businesses.',
  icon: Smartphone,
  image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  category: 'Mobile Development',
  status: 'Available',
  features: [
    // Native iOS Development
    'Native Swift & SwiftUI Development',
    'iOS SDK & Framework Integration',
    'Apple Human Interface Guidelines Compliance',
    'App Store Guidelines & Optimization',
    'TestFlight Beta Testing & Distribution',
    'App Store Connect Integration & Management',

    // User Interface & Experience
    'Custom SwiftUI Component Libraries',
    'Adaptive UI for iPhone & iPad',
    'Dark Mode & Light Mode Support',
    'Accessibility & VoiceOver Integration',
    'Custom Animations & Transitions',
    'Touch ID & Face ID Authentication',

    // Apple Ecosystem Integration
    'iCloud Data Sync & Storage with UK Data Residency',
    'Apple Pay & In-App Purchase Integration for UK Market',
    'Siri Shortcuts & Voice Commands in British English',
    'HealthKit & Fitness Integration with NHS compatibility',
    'Core Location & MapKit Services for UK Geography',
    'Apple Watch App Development with UK Health Standards',

    // Data Management
    'Core Data & CloudKit Integration',
    'SQLite Database Management',
    'Real-Time Data Synchronization',
    'Offline Data Storage & Caching',
    'RESTful API Integration',
    'GraphQL Client Implementation',

    // Performance & Security
    'Code Signing & Certificate Management',
    'App Transport Security (ATS) Compliance',
    'Keychain Services Integration',
    'Background App Refresh Optimization',
    'Memory Management & Performance Tuning',
    'Crash Analytics & Error Reporting',

    // Push Notifications & Communication
    'Apple Push Notification Service (APNs)',
    'Rich Push Notifications & Media',
    'Background Processing & Updates',
    'CallKit & PushKit Integration',
    'MessageKit Chat Implementation',
    'Email & SMS Integration',

    // Media & Content
    'AVFoundation Video & Audio',
    'Camera & Photo Library Integration',
    'Core Image Processing & Filters',
    'Document Scanning & OCR',
    'PDF Generation & Viewing',
    'Augmented Reality (ARKit) Features',

    // Analytics & Monitoring
    'App Analytics & User Behavior Tracking',
    'Firebase Analytics Integration',
    'Custom Event Tracking & Metrics',
    'A/B Testing Implementation',
    'Performance Monitoring & Optimization',
    'User Feedback & Rating Systems',

    // Development Tools & Workflow
    'Xcode Project Setup & Configuration',
    'CocoaPods & Swift Package Manager',
    'Unit Testing & UI Testing',
    'Continuous Integration with Xcode Cloud',
    'Code Review & Version Control',
    'Documentation & Technical Specifications',

    // Third-Party Integrations
    'Social Media SDK Integration',
    'Payment Gateway Implementation',
    'Analytics Platform Connections',
    'Cloud Storage Service Integration',
    'Machine Learning & Core ML',
    'Bluetooth & IoT Device Communication',

    // Maintenance & Support
    '24/7 Technical Support & Monitoring',
    'iOS Version Compatibility Updates',
    'Bug Fixes & Performance Improvements',
    'App Store Review & Approval Support',
    'Feature Updates & Enhancements',
    'Client Training & Documentation',
  ],
  pricing: { setup: 21760, monthly: 450 },
  color: 'from-gray-600 to-slate-700',
  businessTypes: ['#TechStartup', '#MobileFirst', '#AppleEcosystem', '#iOSUsers', '#PremiumBrand'],
});

